import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  Component,
  DestroyRef,
  OnInit,
  ViewChild,
  inject,
  signal,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ReportReservationsByFilters } from '../../../models/reservations-filters-report.model';
import { BussinesService } from '../../../../public/services';
import { ReportReservationsFiltersService } from '../../../services/report-reservations-filters.service';
import { WorkplaceTypeService } from '../../../services/workplace-type.service';
import {
  BuildingService,
  BusinessService,
  FloorService,
  ReservationService,
} from '../../../services';
import { WorkplaceGroupService } from '../../../services/workplace-group.service';
import {
  Building,
  Business,
  Floor,
  TypeOfJob,
  Workplace,
} from '../../../models';
import { SpinnerService, ToastAlertService } from '@core/services';
import { AsyncPipe, DatePipe, NgFor } from '@angular/common';
import { ButtonComponent } from '@shared/components/button/button.component';
import { InputComponent } from '@shared/components/input/input.component';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { TitleComponent } from '@shared/components/title/title.component';
import { MatCardModule } from '@angular/material/card';
import { Cookies } from 'typescript-cookie';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { Observable, map, startWith } from 'rxjs';
import { MatMenu, MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatSortModule } from '@angular/material/sort';
import { ModalAlertComponent } from '@shared/components';
import { MatDialog } from '@angular/material/dialog';
import { ReservationStatus } from '@admin/models/reservataionStatus.model';

@Component({
  selector: 'reservation-report',
  templateUrl: './reservation-report-page.component.html',
  standalone: true,
  imports: [
    MatCardModule,
    TitleComponent,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatSelectModule,
    NgFor,
    MatOptionModule,
    InputComponent,
    ButtonComponent,
    MatTableModule,
    MatPaginatorModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    AsyncPipe,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatMenu,
    MatMenuTrigger,

    ButtonComponent, //
    MatCardModule,
    MatTableModule,
    MatButtonModule,
    MatMenuModule,
  ],
})
export class ReservationReportPageComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  private formBuilder = inject(FormBuilder);
  private reportreservationsService = inject(ReportReservationsFiltersService);
  private alertService = inject(ToastAlertService);
  private businessService = inject(BussinesService);
  private buildingService = inject(BuildingService);
  private workplaceTypeService = inject(WorkplaceTypeService);
  private workerPlaceService = inject(WorkplaceGroupService);
  private floorService = inject(FloorService);
  private pipe = new DatePipe('en-US');
  private destroyRef = inject(DestroyRef);
  private businessServices = inject(BusinessService);
  private reservationService = inject(ReservationService);

  formReports!: FormGroup;
  ptypeJobs: TypeOfJob[] = [];
  buildings: Building[] = [];
  workPlaces: Workplace[] = [];
  floors: Floor[] = [];
  workplacesFilter = signal<Workplace[]>([]);
  myControl = new FormControl('');
  public selectedBussinesName = '';
  public selectedBussines = -1;
  public bussines: Business[] = [];
  public ReservationStatus = signal<ReservationStatus[]>([]);
  private businessIdstate: number | null | undefined;
  formCompleted: boolean = false;
  private dialog = inject(MatDialog);
  private _spinner = inject(SpinnerService);

  displayedColumns: string[] = [
    'start',
    'end',
    'checkin',
    'checkout',
    'name',
    'last_name',
    'email',
    'workstation',
    'jobType',
    'level',
    'building',
    'hours',
    'state',
    'options',
  ];

  dataSource: MatTableDataSource<ReportReservationsByFilters>;
  constructor() {
    this.dataSource = new MatTableDataSource();
    this.buildForm();
  }

  private buildForm() {
    this.formReports = this.formBuilder.group({
      startDate: [''],
      endDate: [''],
      workplaceTypeId: [''],
      buildingId: [''],
      floorId: [''],
      workplaceId: [''],
      worker: [''],
      businessId: [this.selectedBussines, Validators.required],
      reservationStatusId: [''],
    });
  }

  async modalAction(action?: any) {
    const dialogDelete = this.dialog.open(ModalAlertComponent, {
      data: action?.name,
      disableClose: true,
    });
    await dialogDelete.afterClosed().subscribe((result: boolean) => {
      console.log(result);
      if (!result) return;

      if (action) {
        this.reservationService
          .deleteReservations(action?.reservationId)
          .subscribe((response: any) => {
            this.alertService.sucess('Reserva eliminada exitosamente');
            this._spinner.show();
            this.dataSource = new MatTableDataSource();
            //this.ngOnInit();
          });
      }
    });
  }

  findData() {
    if (this.ValidForms()) {
      this.dataSource = new MatTableDataSource<ReportReservationsByFilters>();

      const fields = [
        'workplaceId',
        'buildingId',
        'floorId',
        'workplaceTypeId',
      ];
      fields.forEach(field => {
        const control = this.formReports?.get(field);
        if (control && control.value === -1) {
          control.setValue('');
        }
      });

      this.formReports?.get('businessId')?.setValue(this.selectedBussines);
      this.reportreservationsService
        .getReportReservationsFilters(this.formReports.value, '100000')
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: resp => {
            if (resp.code === 10000 || resp.code === 40009) {
              const content = resp.reply.content || [];
              this.dataSource = new MatTableDataSource(content);
              this.dataSource.paginator = this.paginator;

              if (content.length === 0) {
                this.alertService.error(resp.detail);
              }
            } else {
              this.alertService.error(resp.detail);
            }
          },
        });
    }
  }

  submit() {}
  ngOnInit(): void {
    this.role();
    this.getBusiness();
    const business = Cookies.get('bussinesId');
    if (business != null) {
      this.businessIdstate = parseInt(business.toString());
      this.selectedBussines = this.businessIdstate;
    } else {
      this.selectedBussines = -1;
      this.businessIdstate = null;
    }
    this.chargueDataForm();
  }
  private getBusiness() {
    this.businessServices
      .getBusiness()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (request: any) => {
          if (request.code === 10000 || request.code === 40009) {
            this.bussines = request.reply;
            this.filteredOptions = this.myControl.valueChanges.pipe(
              startWith(''),
              map(value => this._filter(value))
            );
          }
        },
      });
  }
  ValidBusiness_id(): boolean {
    return this.businessIdstate === null;
  }

  ValidForms(): boolean {
    if (this.selectedBussines !== -1) {
      return true;
    } else {
      return false;
    }
  }

  chargueDataForm() {
    this.getBusiness();
    if (this.selectedBussines !== -1) {
      this.chargueTypeJobs();
      this.chargueBuilding();
      this.chargeTypeReservations();
    }
  }
  private chargeTypeReservations() {
    this.reservationService
      .getReservationsTyope()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          this.ReservationStatus.set(resp.reply);
        },
      });
  }

  private chargueTypeJobs() {
    this.workplaceTypeService
      .getWorkplaces(this.selectedBussines)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          if (resp.code === 10000 || resp.code === 40009) {
            const typeOfJob = {
              workplacetypeid: -1,
              name: '--',
              description: '',
              recurrence: -1,
              maxcapacity: -1,
              isparking: '',
              blockstatus: -1,
              icon: '',
              color: '',
            };
            this.ptypeJobs = [typeOfJob, ...resp.reply];
          } else {
            this.alertService.error(resp.detail);
          }
        },
      });
  }

  private chargueBuilding() {
    if (this.selectedBussines !== -1) {
      this.buildingService
        .getBuildings(this.selectedBussines)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: resp => {
            if (resp.code === 10000 || resp.code === 40009) {
              const buildingPredeter = {
                buildingid: -1,
                name: '--',
                code: '',
                address: '',
                city: '',
                country: '',
                country_id: -1,
                idBusiness: -1,
                latitude: -1,
                longitude: -1,
              };
              this.buildings = [buildingPredeter, ...resp.reply];
            } else {
              this.alertService.error(resp.detail);
            }
          },
        });
    }
  }

  chargueWorkplaces(idFloor: number) {
    if (idFloor !== -1) {
      this.workerPlaceService
        .getWorkplaceByFloor(idFloor)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: resp => {
            if (resp.code === 10000 || resp.code === 40009) {
              const workplace = {
                workplaceid: -1,
                name: '--',
                code: -1,
                description: '',
                phone: '',
                x: -1,
                y: -1,
                status: -1,
                workplacetypeid: -1,
                roleid: -1,
                workplacegroupid: -1,
              };
              this.workPlaces = [workplace, ...resp.reply];

              const type = this.formReports?.get('workplaceTypeId')?.value;
              console.log('type', type);
              this.filterWorkplacesByTypeId(type);
            } else {
              this.alertService.error(resp.detail);
            }
          },
        });
    }
  }

  filterWorkplacesByTypeId(typeId: number) {
    console.log('Filtrando', typeId);
    if (typeId > 0) {
      console.log('True');
      const workplace = {
        workplaceid: -1,
        name: '--',
        description: '',
        id: -1,
        code: -1,
        phone: '',
        x: 1,
        y: 1,
        status: 1,
        workplacetypeid: -1,
        roleid: 1,
        workplacegroupid: -1,
      };
      const filteredWorkplaces = this.workPlaces.filter(
        workplace => workplace.workplacetypeid === typeId
      );
      filteredWorkplaces.unshift(workplace);

      this.workplacesFilter.set(filteredWorkplaces);
    } else {
      console.log('False');
      this.workplacesFilter.set(this.workPlaces);
    }
  }

  chargueFloorByBuilding(buldingid: number) {
    if (buldingid !== -1) {
      this.floors = [];
      this.workPlaces = [];
      this.floorService
        .getFloorsByBuilding(buldingid)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: resp => {
            if (resp.code === 10000 || resp.code === 40009) {
              const floor = {
                floorid: -1,
                name: '--',
                description: '',
                map: '',
                buildingid: -1,
                isParking: 1,
              };
              this.floors = resp.reply || [];
              this.floors = [floor, ...resp.reply];
            } else {
              this.alertService.error(resp.detail);
            }
          },
        });
    }
  }

  downloadCsv() {
    if (this.ValidForms()) {
      this.formReports?.get('businessId')?.setValue(this.selectedBussines);
      this.reportreservationsService
        .getReportReservationsFiltersCsv(this.formReports.value)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((data: Blob) => {
          if (data.type == 'application/json') {
            this.alertService.warning('No hay datos para descargar.');
          } else {
            const file = new Blob([data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'reporte_reservaciones.csv';
            link.click();
            window.URL.revokeObjectURL(url);
          }
        });
    }
  }

  downloadPDF(): void {
    if (this.ValidForms()) {
      this.formReports?.get('businessId')?.setValue(this.selectedBussines);
      this.reportreservationsService
        .getReportReservationsFiltersPdf(this.formReports.value)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((data: Blob) => {
          if (data.type == 'application/json') {
            this.alertService.warning('No hay datos para descargar.');
          } else {
            const file = new Blob([data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'reporte_reservaciones.pdf';
            link.click();
            window.URL.revokeObjectURL(url);
          }
        });
    }
  }

  clearForm() {
   this.selectedBussinesName = '';
   this.myControl.setValue(null);
    this.buildForm();
  }
  isrole: boolean = true;
  role() {
    const role = Cookies.get('role');
    if (role && role === 'SYSADMIN') {
      this.isrole = true;
    } else {
      this.isrole = false;
    }
  }
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

  onOptionSelected(value: number, name: string) {
    this.selectedBussines = value;
    this.selectedBussinesName = name;
    this.myControl.setValue(this.selectedBussinesName);
    this.applyFilter();
  }

  filteredOptions: Observable<Business[]> = new Observable<Business[]>(
    observer => {
      observer.next([]);
    }
  );
  applyFilter() {
    const value = this.myControl.value;
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(value),
      map(value => this._filter(value))
    );
  }

  private _filter(value: string | null): Business[] {
    const filterValue = (value || '').toLowerCase();
    // Actualiza el valor de búsqueda anterior
    if (!filterValue) {
      return this.bussines;
    }
    return this.bussines.filter(
      bussines =>
        this.removeDiacritics(bussines.name.toLowerCase()).includes(
          this.removeDiacritics(filterValue)
        ) ||
        (bussines.idBusiness !== undefined &&
          bussines.idBusiness.toString().includes(filterValue))
    );
  }
  removeDiacritics(text: string): string {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
}
